import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../styles/congratulations.css';
import { useMetadata } from '../hooks/useMetadata';
import { REACT_APP_CLIENT_PORTAL_CTA } from '../config';
import { shouldShowPortalCta } from './congratulationsPortalCta';
import { clearApplicationSignatureMark } from '../utils/applicationSignatureMark';

const CongratulationsPage: React.FC = () => {
  useMetadata();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const quoteID = searchParams.get('quoteID') || '';
  const showPortalCta = Boolean(quoteID) && shouldShowPortalCta(REACT_APP_CLIENT_PORTAL_CTA);
  const signatureFailed = searchParams.has('error');

  // OUW-276: api-client manda acá también una firma cancelada o con error (`?error=`). Esa vuelta
  // no es «recién firmó»: si desde aquí entra al portal, el aviso de firma recibida no aparece.
  useEffect(() => {
    if (signatureFailed) clearApplicationSignatureMark();
  }, [signatureFailed]);

  return (
    <div className="congratulations-container">
      <div className="congratulations-header">
        <img 
          src="/logo-ole-mx.png" 
          alt="Olé Logo" 
          className="congratulations-logo"
        />
      </div>
      
      <div className="congratulations-content">
        <div className="congratulations-message">
          <h1 data-testid="felicitaciones-titulo-exito" className="congratulations-title">
            ¡Tu solicitud ha sido enviada con éxito!
          </h1>
          <p data-testid="felicitaciones-texto-descripcion" className="congratulations-description">
            {quoteID ? (
              <>
                Tu solicitud está en revisión. Te avisamos por correo a{' '}
                <b>{email}</b>
                {' '}cuando tengamos una respuesta.
              </>
            ) : (
              <>
                En las próximas 24 horas enviaremos la confirmación de tu evaluación a{' '}
                <b>{email}</b>
              </>
            )}
          </p>
          {showPortalCta ? (
            <a
              className="congratulations-cta"
              data-testid="felicitaciones-cta-portal"
              href={`/status/solicitud?quoteID=${encodeURIComponent(quoteID)}`}
            >
              Ver el estado de mi solicitud
            </a>
          ) : null}
        </div>
        
        <div className="congratulations-image">
          <img 
            src="/congratulations family.png" 
            alt="Familia feliz" 
            className="family-image"
          />
        </div>
      </div>
    </div>
  );
};

export default CongratulationsPage;
